import { ref } from 'vue';
import { fetchAllMembersAsUsers } from '@/entities/User';

interface UserOption {
  id: number | string;
  name: string;
}

const isUserOption = (user: UserOption | null): user is UserOption => user !== null;

export default function useDocumentUsers(options: { excludeCurrentUser?: boolean } = {}) {
  const { excludeCurrentUser = true } = options;
  const userOptions = ref<UserOption[]>([]);
  const selectedUser = ref<number | string>('');
  const isLoading = ref(false);
  const error = ref<string | null>(null);

  const fetchUsers = async () => {
    isLoading.value = true;
    error.value = null;

    try {
      const users = await fetchAllMembersAsUsers(undefined, {
        requiredPermissionAction: 'manageApproval',
        requiredPermissionSubject: 'Homologation',
        excludeCurrentUser,
      });

      userOptions.value = users
        .map<UserOption | null>((user) => {
          const id = user.membership?.id ?? user.memberships?.[0]?.id;

          if (id == null) {
            return null;
          }

          return {
            id,
            name: user.name ?? '',
          };
        })
        .filter(isUserOption);
    } catch (err) {
      error.value = err instanceof Error ? err.message : 'Erro ao buscar membros';
      userOptions.value = [];
      throw err;
    } finally {
      isLoading.value = false;
    }
  };

  return {
    userOptions,
    selectedUser,
    isLoading,
    error,
    fetchUsers,
  };
}
